import { Component, Inject, Input, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatError } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';
import { AssetUrlPipe } from '../../pipes/asset-url.pipe';
@Component({
    selector: 'app-create-file-dialog',
    templateUrl: './create-file-dialog.component.html',
    styleUrl: './create-file-dialog.component.scss',
    imports: [CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatError, MatButton, AssetUrlPipe]
})
export class CreateFileDialogComponent {
  inputForm!: FormGroup;
  fieldTitle: any;
  buttonName: any;
  control: any;
  dialogTitle: any = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<CreateFileDialogComponent>
  ) {
    if (data) {
      this.fieldTitle = data?.title;
      this.buttonName = data.type;
      this.dialogTitle = data.dialogTitle ?? '';
    }
  }

  ngOnInit(): void {
    this.inputForm = this.formBuilder.group({
      folderName: new FormControl(this.data.fileName, Validators.required)
    });
  }

  returnResult() {
    if (this.inputForm.invalid) {
      this.inputForm.markAllAsTouched();
      return;
    }
    this.dialogRef.close(this.inputForm.value);
  }

  close() {
    this.dialogRef.close(false);
  }
}
